import HomepageBookCallButton from './HomepageBookCallButton'
import { fitCards } from './config'

function HomepageFitSection() {
    return (
        <section className="border-b border-black/10 bg-white py-14">
            <div className="container mx-auto px-5 md:px-0">
                <div className="mb-8 max-w-[760px]">
                    <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.08em] text-[#F28230]">
                        Built for serious direct mail
                    </div>
                    <h2 className="mb-3 text-[clamp(26px,3.2vw,44px)] font-extrabold leading-[1.12] tracking-[-0.025em] text-[#3F454F]">
                        <span>Already mailing — or ready to launch </span>
                        <span className="olm-gradient-text">
                            with the budget to do it right?
                        </span>
                    </h2>
                    <p className="max-w-[560px] text-[17px] leading-[1.75] text-[#6F7785]">
                        OLM is built for companies that want direct mail to be
                        more than a one-off postcard order. We help teams
                        improve targeting, creative, timing, production,
                        automation, and consistency across real campaigns.
                    </p>
                </div>

                <div className="grid gap-4 md:grid-cols-3">
                    {fitCards.map((card) => (
                        <div
                            key={card.title}
                            className="rounded-[18px] border border-black/10 bg-[#FFF9F2] p-6 transition hover:-translate-y-0.5 hover:border-[rgba(237,92,47,0.2)] hover:shadow-[0_14px_36px_-12px_rgba(0,0,0,0.09)]">
                            <div
                                className={`mb-4 flex h-[42px] w-[42px] items-center justify-center rounded-[11px] text-[20px] leading-none ${card.badgeClass}`}>
                                {card.icon}
                            </div>
                            <h3 className="mb-2 text-xl font-bold tracking-[-0.015em] text-[#3F454F]">
                                {card.title}
                            </h3>
                            <p className="text-[14.5px] leading-[1.65] text-[#6F7785]">
                                {card.description}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="relative mt-[22px] flex flex-col gap-8 overflow-hidden rounded-[20px] bg-[#3F454F] px-7 py-7 md:flex-row md:items-center md:justify-between md:px-[38px] md:py-8">
                    <div className="pointer-events-none absolute right-0 top-0 hidden h-full w-[300px] bg-[radial-gradient(circle_at_right,rgba(237,92,47,0.18)_0%,transparent_65%)] md:block" />
                    <div className="relative z-10">
                        <div className="relative mb-2 text-[11px] font-extrabold uppercase tracking-[0.12em] text-[#FAB331]">
                            Ready to get started?
                        </div>
                        <div className="text-[clamp(22px,2.4vw,30px)] font-extrabold leading-[1.15] tracking-[-0.025em] text-white">
                            Launch smarter. Scale faster.
                        </div>
                    </div>
                    <HomepageBookCallButton
                        className="relative z-10 px-[30px] py-[15px] text-[15px]"
                        variant="primary">
                        Book a call
                    </HomepageBookCallButton>
                </div>
            </div>
        </section>
    )
}

export default HomepageFitSection
